import { BCMSRecord, useBCMSContext, useModel, useRoute } from "@bcm-dev/bcms-vite";
import Classes from "model";
import React from 'react';

/**
 * @function MainPage
 * @param {String} className - Allows us to set a custom class name for the component
 * @return {React.Component}
 * @exported true
 * @description The Page that shows either login or home page
 */

export default function MainPage(props){
  const navigate = useRoute();
  const controller = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, controller);
        const { branding } = useModel();
    const options = branding.options ?? {}
   
   setTimeout(function(){
     navigate(`/${options.standalone_chw23 ==="true"?"login":"home/recenttransactions/"}`)
   },100)
   
  return(
    <></>
  );
}